import {
  AGENT_LOADING,
  GET_AGENT,
  GET_AGENT_SUCCESS,
  GET_AGENT_FAIL,
  ADD_AGENT_SUCCESS,
  ADD_AGENT_FAIL,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAIL,
  UPDATE_AGENT_SUCCESS,
  UPDATE_AGENT_FAIL,
  AGENT_RESET,
  AGENT_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  agents: [],
  agentAdded: {},
  error: {},
};

const Agent = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AGENT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_AGENT:
          return {
            ...state,
            agents: action.payload.data,
            isAgentCreated: false,
            isAgentSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_AGENT_FAIL:
      switch (action.payload.actionType) {
        case GET_AGENT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isAgentCreated: false,
            isAgentSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_AGENT: {
      return {
        ...state,
        isAgentCreated: false,
        loading: true,
      };
    }

    case AGENT_LOADING: {
      return {
        ...state,
        isAgentCreated: false,
        loading: true,
      };
    }

    case ADD_AGENT_SUCCESS:
      return {
        ...state,
        isAgentCreated: true,
        loading: false,
        agents: [action.payload.data, ...state.agents],
        agentAdded: action.payload.data,
      };

    case ADD_AGENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: state.agents.filter(
          agent => agent.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_AGENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_AGENT_SUCCESS:
      return {
        ...state,
        loading: false,
        agents: state.agents.map(agent =>
          agent.id.toString() === action.payload.data.id.toString() ? { ...agent, ...action.payload.data } : agent
        ),
      };

    case UPDATE_AGENT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case AGENT_RESET_CREATE:
      return {
        ...state,
        isAgentCreated: false,
      };

    case AGENT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Agent;